import * as React from 'react';
import {ScrollView, StyleSheet, TextStyle, View, ViewStyle} from 'react-native';

import ServiceExplanationStep1 from './ServiceExplanationStep1';
import ServiceExplanationStep2 from './ServiceExplanationStep2';
import ServiceExplanationStep3 from './ServiceExplanationStep3';
import ServiceExplanationStep4 from './ServiceExplanationStep4';

import DimensionContext from '../../../shared/dimension/DimensionContext';

interface InnerProps {
  width: number;
  onAgreeServicePolicy: () => void;
}

const ServiceExplanationInnter: React.FunctionComponent<InnerProps> = props => {
  const {width, onAgreeServicePolicy} = props;
  const scrollViewRef = React.useRef<ScrollView | null>(null);
  const [step, setStep] = React.useState<1 | 2 | 3>(1);
  const onPressStep1 = React.useCallback(() => {
    setStep(2);
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({x: width});
    }
  }, [scrollViewRef]);
  const onPressStep2 = React.useCallback(() => {
    setStep(3);
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({x: width * 2});
    }
  }, [scrollViewRef]);
  const onPressStep3 = React.useCallback(() => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({x: width * 3});
    }
  }, [scrollViewRef]);
  const onPressStep4 = React.useCallback(() => {
    onAgreeServicePolicy();
  }, [scrollViewRef]);
  const style = React.useMemo(() => {
    return {width, flex: 1};
  }, [width]);
  return (
    <ScrollView
      ref={scrollViewRef}
      pagingEnabled={true}
      horizontal={true}
      scrollEnabled={false}>
      <View style={style}>
        <ServiceExplanationStep1 onPress={onPressStep1} />
      </View>
      <View style={style}>
        <ServiceExplanationStep2 onPress={onPressStep2} />
      </View>
      <View style={style}>
        <ServiceExplanationStep3 onPress={onPressStep3} />
      </View>
      <View style={style}>
        <ServiceExplanationStep4 onPress={onPressStep4} />
      </View>
    </ScrollView>
  );
};

interface Props {
  onAgreeServicePolicy: () => void;
}

const ServiceExplanation: React.FunctionComponent<Props> = props => {
  return (
    <DimensionContext.Consumer>
      {context => {
        const width = context.content.width;
        return <ServiceExplanationInnter {...props} width={width} />;
      }}
    </DimensionContext.Consumer>
  );
};

export default React.memo(ServiceExplanation);

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fafafa',
    borderTopColor: '#efefef',
    borderTopWidth: 1,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  } as ViewStyle,
  message: {
    color: '#222',
    fontSize: 14,
  } as TextStyle,
});
